import { render, staticRenderFns } from "./PelleTab.vue?vue&type=template&id=7418d720&scoped=true"
import script from "./PelleTab.vue?vue&type=script&lang=js"
export * from "./PelleTab.vue?vue&type=script&lang=js"
import style0 from "./PelleTab.vue?vue&type=style&index=0&id=7418d720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7418d720",
  null
  
)

export default component.exports